<template>
  <PageContent>
    <h2>
      Bismarck Analysis helps companies, governments, philanthropists, and
      investors in their vital role of maintaining and advancing our
      civilization.
    </h2>
    <section>
      <p>
        We build long-term partnerships with select clients who aim to make a
        difference in the world.
      </p>
      <p>
        Our unique analysis is made possible by a decade of research into the
        functioning of institutions and the strategy of live players. We further
        make use of cross-disciplinary expertise ranging from psychology to
        economics.
      </p>
    </section>
  </PageContent>
</template>

<script>
import PageContent from "./PageContent.vue";
export default {
  name: "Main",
  components: { PageContent },
  beforeCreate() {
    document.title = "Bismarck Analysis";
  },
};
</script>

<style scoped>
h2 {
  margin-top: 3em;
  line-height: 135%;
  margin-bottom: 2em;
  padding-right: 5%;
}

/* Close enough */
@media screen and (min-width: 600px) {
  section {
    width: 90%;
  }
}
@media screen and (min-width: 900px) {
  section {
    width: 80%;
  }
}
</style>
